import styles from "../CreatorsPage.module.scss";
import Calculator from "./Calculator";

const Earn = () => (
	<section className={styles.earn2} id="earn" aria-labelledby="earn-h">
		<div className={`${styles.wrap} ${styles.e2}`}>
			<div className={styles.e2Copy}>
				<span className={styles.eyebrow}>How you earn</span>
				<h2 className={styles.h2} id="earn-h">
					Your followers travel. <span className={styles.hl}>You get paid.</span>
				</h2>
				<p className={styles.lede}>
					Every follower who plans a trip pays you. Every guide you sell pays you more. Your own links pay on top, and joining is free.
				</p>
				<div className={styles.nums}>
					<div>
						<b>€0.50</b>
						<span>per traveller who joins through you and plans a trip</span>
					</div>
					<div>
						<b>80%</b>
						<span>of every paid guide sold through Stippl</span>
					</div>
					<div>
						<b>100%</b>
						<span>of the commission on your own links</span>
					</div>
				</div>
			</div>
			<Calculator />
		</div>
	</section>
);

export default Earn;
